import type { SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Golden Paddy Traders',
    tagline: 'Wholesale rice traders',
    description: 'Wholesale basmati, non-basmati, parboiled and broken rice, graded, lab-checked and packed to your specification for distributors, retailers, food service and importers.',
    url: getOrigin(),
    contact: {
        phone: '',
        whatsapp: '',
        email: '',
        address: '',
        hours: ''
    }
}
